import React, { createRef } from "react";
import { flowCategoryId } from "../../../../publicDictionaryValues";
import ReadOnlyCreateSupportingFileSection from "../../../../sections/supportingFileSections/readOnlyCreateSupportingFileSection";
import BaseNewSupportingFileComplete from "../../baseNewSupportingFile/baseNewSupportingFileComplete";

const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
export default class SupportingFileSubmitComplete extends BaseNewSupportingFileComplete {
  handleReturnPageName = () => {
    if (this.props.pageProps.flowCategoryID === flowCategoryId.copySupportingFile) {
      return "Copy Supporting File";
    }

    return "Create New Supporting File";
  };

  handleReturnSupportingFileSection = () => {
    const { data } = this.props;
    return (
      <ReadOnlyCreateSupportingFileSection
        supportingFileRef={supportingFileRef}
        supportingFileTableRef={supportingFileTableRef}
        supportingFileData={data}
        isCopyPage={this.props.isCopyPage}
      />
    );
  };
}
